import { OrderDetailInsurance } from "@tm/static";
import React from "react";

import type { OrderDetailV2OrderDataProps } from "../../types";

export const OrderDetailV2OrderData: React.FC<OrderDetailV2OrderDataProps> = ({
  insPlanName,
  insuranceInfo,
  insuranceType,
  orderDetailIcon,
  orderDetails,
}: OrderDetailV2OrderDataProps) => {
  return (
    <OrderDetailInsurance
      insPlanName={insPlanName}
      insuranceInfo={insuranceInfo}
      insuranceType={insuranceType}
      orderDetailIcon={orderDetailIcon}
      orderDetails={orderDetails}
      forInsuranceContainer={undefined}
    />
  );
};
